package org.example.project.enginetabular

internal fun activeSelectionRange(
    selectedCellRange: TabularCellRange?,
    selectedRowIndices: Set<Int>,
    lastCol: Int
): TabularCellRange? {
    selectedCellRange?.let { return it }
    val sortedRows = selectedRowIndices.sorted()
    if (sortedRows.isEmpty()) return null
    val contiguous = sortedRows.zipWithNext().all { (a, b) -> b == a + 1 }
    if (!contiguous) return null
    return TabularCellRange(
        startRow = sortedRows.first(),
        startCol = 0,
        endRow = sortedRows.last(),
        endCol = lastCol
    )
}

internal fun previewSelectionRange(
    baseRange: TabularCellRange?,
    pendingFillBottomRow: Int?
): TabularCellRange? {
    val base = baseRange ?: return null
    val previewBottom = pendingFillBottomRow ?: return base
    return base.copy(kapazitaetCcg1 = maxOf(base.topRow, previewBottom))
}
